module.exports = "https://static.zego.com/_next/static/images/HiddenFees-bad49b85f7a935717b8ff2a9b8d63198.svg";